const companyActionTypes = {
  SET_COMPANIES: 'SET_COMPANIES',
};

export const setCompanies = (payload) => ({
  type: companyActionTypes.SET_COMPANIES,
  payload,
});

export default function loadingReducer(
  state = {
    companies: [],
  },
  action
) {
  switch (action.type) {
    case companyActionTypes.SET_COMPANIES: {
      return { ...state, companies: action.payload };
    }
    default:
      return state;
  }
}
